import type { StorefrontBuyerCurrency } from '@stokmerter/contracts';
import { useState } from 'react';

import {
  colorsImage,
  flatImage,
  formatBuyerPrice,
  lifestyleImages,
  priceMinor,
  primaryImage,
  type CatalogProduct,
  type CatalogViewType,
} from './catalog-types';

export function CatalogProductCard(props: {
  currency: StorefrontBuyerCurrency;
  onOpen: (product: CatalogProduct) => void;
  product: CatalogProduct;
  viewType: CatalogViewType;
}) {
  const { currency, onOpen, product, viewType } = props;
  const [tab, setTab] = useState<'detail' | 'colors'>('detail');
  const [imageIndex, setImageIndex] = useState(0);
  const lifestyle = lifestyleImages(product);
  const detailImage = viewType === 'flat'
    ? flatImage(product) ?? primaryImage(product, viewType)
    : lifestyle[imageIndex] ?? primaryImage(product, viewType);
  const image = tab === 'colors' ? colorsImage(product) ?? detailImage : detailImage;
  const available = product.payload.colors.some((color) => color.availability === 'in_stock');

  function rotate(direction: -1 | 1) {
    if (lifestyle.length < 2 || viewType === 'flat') return;
    setImageIndex((current) => (current + direction + lifestyle.length) % lifestyle.length);
  }

  return <article className="product-card">
    <div className="product-media-wrap">
      <button className={`product-media ${tab === 'colors' ? 'contain' : viewType}`}
        onClick={() => onOpen(product)} type="button">
        {image ? <img alt={product.payload.productName} src={image} />
          : <span className="image-placeholder">Görsel yok</span>}
      </button>
      <span className={`stock-badge ${available ? '' : 'out'}`}>{available ? 'Stokta' : 'Stokta yok'}</span>
      {tab === 'detail' && viewType === 'lifestyle' && lifestyle.length > 1 ? <>
        <button aria-label="Önceki görsel" className="card-arrow previous" onClick={() => rotate(-1)} type="button">‹</button>
        <button aria-label="Sonraki görsel" className="card-arrow next" onClick={() => rotate(1)} type="button">›</button>
        <div className="card-dots" aria-hidden="true">{lifestyle.map((_, index) =>
          <i className={index === imageIndex ? 'active' : ''} key={index} />)}</div>
      </> : null}
    </div>
    <div className="product-card-tabs" role="tablist">
      <button aria-selected={tab === 'detail'} className={tab === 'detail' ? 'active' : ''}
        onClick={() => setTab('detail')} role="tab" type="button">Detaylar</button>
      <button aria-selected={tab === 'colors'} className={tab === 'colors' ? 'active' : ''}
        onClick={() => setTab('colors')} role="tab" type="button">Ürün Renkleri</button>
    </div>
    <button className="product-copy" onClick={() => onOpen(product)} type="button">
      <span><b>{product.payload.productCode}</b> · {product.payload.productName}</span>
      <strong>{formatBuyerPrice(priceMinor(product, currency), currency)}</strong>
    </button>
  </article>;
}
